var defaultConfig = {
    backendUrl: 'https://api.quicksmart.ai',
    ENV: 'development',
    livekitUrl: 'wss://talkbot-klk047q5.livekit.cloud',
    livekitTokenUrl: 'http://localhost:3001'
};
export var getEnvConfig = function () {
    if (typeof window === 'undefined')
        return defaultConfig;
    return {
        backendUrl: process.env.PUBLIC_BACKEND_URL || defaultConfig.backendUrl,
        ENV: process.env.NODE_ENV || defaultConfig.ENV,
        livekitUrl: process.env.LIVEKIT_URL || defaultConfig.livekitUrl,
        livekitTokenUrl: process.env.LIVEKIT_TOKEN_URL || defaultConfig.livekitTokenUrl
    };
};
export var env = getEnvConfig();
